import React from "react";

export default function StatisticsPage() {
  return <div>StatisticsPage</div>;
}
